// 通用字段
export interface OperatorAction {
  action: string
  label: string
  enabled: boolean
  reason?: string
}

export interface RiskFlag {
  code: string
  label: string
  level: 'info' | 'warning' | 'danger'
}

export interface StatusEvent {
  from_status: string
  to_status: string
  actor: string
  note?: string
  created_at: string
}

export type MessageStatus = 'normalized' | 'pending_response' | 'responded' | 'drafted' | 'closed_no_ticket' | 'binding_required'

export type DraftStatus = 'drafted' | 'need_more_info' | 'binding_required' | 'confirmed' | 'created_task' | 'rejected'

export type PlatformStatus = 'received' | 'draft_confirming' | 'need_more_info' | 'waiting_start' | 'doing' | 'waiting_customer_confirm' | 'returned' | 'closed'

export type SlaEventStatus = 'open' | 'reminded' | 'ignored' | 'resolved'

export type Priority = 'P1' | 'P2' | 'P3'

// 状态字典映射
export const MESSAGE_STATUS_MAP: Record<string, string> = {
  normalized: '已入库',
  pending_response: '待响应',
  responded: '已响应',
  drafted: '已转草稿',
  closed_no_ticket: '无需建单',
  binding_required: '待补绑定',
}

export const DRAFT_STATUS_MAP: Record<string, string> = {
  drafted: '待审核',
  need_more_info: '待补信息',
  binding_required: '待补绑定',
  confirmed: '已确认',
  created_task: '已建单',
  rejected: '不建单',
}

export const PLATFORM_STATUS_MAP: Record<string, string> = {
  received: '已接收',
  draft_confirming: '草稿确认中',
  need_more_info: '待补信息',
  waiting_start: '待接单',
  doing: '处理中',
  waiting_customer_confirm: '待客户确认',
  returned: '已退回',
  closed: '已关闭',
}

export const SLA_EVENT_STATUS_MAP: Record<string, string> = {
  open: '待处理',
  reminded: '已提醒',
  ignored: '已忽略',
  resolved: '已解决',
}
